import moment from 'moment';

export const MILE_TO_METER = 1609.34;

export const convertSecondToHour = (seconds) => {
  if (!seconds) return '';
  const duration = moment.duration(seconds, 'seconds');

  //calculate hours
  const hh = duration.years() * (365 * 24) + duration.months() * (30 * 24) + duration.days() * 24 + duration.hours();

  //get minutes
  const mm = duration.minutes();
  if (hh === 0) return mm + 'mins';
  //return total time in hh:mm format
  return hh + 'hrs ' + mm + 'mins';
};

export const convertMeterToMile = (val, decimal_number = 1) => {
  return (val / MILE_TO_METER).toFixed(decimal_number);
};
